const KEY = 'glyphicai-logged-in'
const TOKEN_KEY = 'glyphicai-satoken'

/** 本地存储用户端 Sa-Token（请求头名 `satoken`，见 @glyphic/shared-core） */
export function getAuthToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY)?.trim() || null
  } catch {
    return null
  }
}

export function setAuthToken(token: string): void {
  try {
    localStorage.setItem(TOKEN_KEY, token.trim())
  } catch {
    /* ignore */
  }
}

export function isLoggedIn(): boolean {
  return getAuthToken() != null
}

export function markLoggedIn(): void {
  try {
    localStorage.setItem(KEY, '1')
  } catch {
    /* ignore */
  }
}

export function clearSession(): void {
  try {
    localStorage.removeItem(KEY)
    localStorage.removeItem(TOKEN_KEY)
  } catch {
    /* ignore */
  }
}
